import {
  CreatePrintingTechniqueType,
  CreatePrintingTechniqueTypes,
} from "./data";

const setStateValue = (
  key: CreatePrintingTechniqueTypes,
  value: any,
): CreatePrintingTechniqueType => ({
  type: key,
  payload: value,
});

export const PrintingTechniqueActions = {
  setStateValue,
};
